import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { Color } from 'src/app/utils/color.enum';
import { IBtnEvento } from 'src/app/custom-components/interfaces/btn-evento.interface';
import { IBtn } from 'src/app/custom-components/interfaces/btn.interface';
import { AplicacionTipoService } from 'src/app/_module/procesadora/aplicacion-datos/aplicacion-tipo/aplicacion-tipo.service';
import { DialogComponent } from 'src/app/custom-components/dialog/dialog.component';
import { DialogTipo } from 'src/app/custom-components/dialog/utils/dialog-type.enum';
import {MatDialog, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DialogConfig } from 'src/app/custom-components/dialog/interfaces/dialog-config.interface';
import { AplicacionTipo } from 'src/app/_models/aplicacion-tipo';
import { Listas } from 'src/app/_helpers/clases/listas';
import {PageHeaderDataService} from 'src/app/shared/services/page-header-data.service';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';
import {NotificacionesService} from 'src/app/_app_services/notificaciones.service';

/**
  * Listado de los Tipos de Aplicaciones utilizadas por el usuario
  * @author Alejandro Planas,David Ozorio
  */
@Component({
  selector: 'app-aplicacion-tipo-list',
  templateUrl: './aplicacion-tipo-list.component.html',
  styleUrls: ['./aplicacion-tipo-list.component.scss'],
})
export class AplicacionTipoListComponent extends Listas<AplicacionTipo> implements OnInit {
  tableColumns = [{name: 'Aplicación', val: 'nombre'}
  ];
     
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public service: AplicacionTipoService,
    private headerDataService: PageHeaderDataService
  ) {
    super(router, 'procesadora/aplicacion_tipo', service, dialog);
  }

  ngOnInit(): void {
    this.headerDataService.setHeaderData(new PageHeaderData('Tipo de aplicación', this.rutaPadre + '/registrar', false, true));
  } 
}
